import {Component, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {EquipmentService} from '../service/equipment.service';
import {BusyProvider} from '../service/busy.service';
import {AppConstants} from '../core/app.constants';
import {Router} from '@angular/router';
import {UserContext, BaseComponent, Equipment, EquipmentsRequest, EquipmentType, EquipmentUser, EquipmentUsersRequest, User} from '../core/core.component';
import {SelectItem} from 'primeng/primeng';
import {Message} from 'primeng/components/common/api';
import {ConfirmationService} from 'primeng/primeng';
import { filter } from 'rxjs/operator/filter';
import { UserService } from 'app/service/user.service';

@Component({
  selector: 'app-equipment-defs',
  templateUrl: './equipment-defs.component.html',
  styleUrls: ['./equipment-defs.component.css'],
})
export class EquipmentDefsComponent extends BaseComponent implements OnInit {

  private pattern = 'yyyy-MM-dd';

  locale: any = AppConstants.ITA_CALENDAR_CONF;
  userContext: UserContext;
  loading = false;
  showDeleteAlert = false;
  showFilter = false;

  showAssignDialog = false;
  assignIdUser: number = null;
  users: SelectItem[] = [];

  showDeAssignAlert = false;

  showEquipmentTypesDialog = false;
  equipmentType: EquipmentType = new EquipmentType();

  types: SelectItem[] = [];
  typesWithMac: number[] = [];

  filterSoloAttivi = true;
  filterAssegnate = true;
  filterNonAssegnate = true;
  filterDesc: string = null;
  filterIdTipo: number = null;
  filterSerialNumber: string = null;
  filterDataAcquistoDa: Date = null;
  filterDataAcquistoA: Date = null;
  filterCodCespite: string = null;
  filterDataAlienazioneDa: Date = null;
  filterDataAlienazioneA: Date = null;

  equipments: Equipment[] = [];
  filteredEquipments: Equipment[] = [];

  equipmentSelected: Equipment = new Equipment();
  validationMessage: string = null;

  sortField = 'desc';
  sortAsc = true;

  equipmentId: number = null;
  equipmentDesc = '';
  equipmentIdTipo: number = null;
  equipmentSN = '';
  equipmentDataAcquisto: Date = new Date();
  equipmentCodCespite = '';
  equipmentDataAlienazione: Date = null;
  equipmentMacAddress = null;
  equipmentNote = '';
  
  equipmentUsers: EquipmentUser[] = [];
  equipmentUsersStorico: EquipmentUser[] = [];

  msgs: Message[] = [];

  toScroll: boolean = false;

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userService: UserService,
    private equipmentService: EquipmentService,
    private busyProvider: BusyProvider,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.resetFilter();
      this.loadEquipmentTypes();
      this.loadEquipments();
    }
  }

  resetFilter() {
    this.filterDesc = null;
    this.filterIdTipo = null;
    this.filterSerialNumber = null;
    this.filterDataAcquistoDa = null;
    this.filterDataAcquistoA = null;
    this.filterCodCespite = null;
    this.filterDataAlienazioneDa = null;
    this.filterDataAlienazioneA = null;
  }

  loadEquipmentTypes() {
    this.types = [];
    this.equipmentService.getEquipmentTypes(this.userContext.srmToken).subscribe(
      result => {
        this.types.push({label: '', value: null});
        const types = result.types;
        for (let i = 0; i < types.length; ++i) {
          const current: EquipmentType = types[i];
          this.types.push({label: current.desc, value: current.id});
          if (current.flagMac) {
            this.typesWithMac.push(current.id);
          }
        }
      },
      error => {
        this.handleError(error);
      });
  }

  loadEquipments() {
    this.equipments = [];
    this.loading = true;
    const request = new EquipmentsRequest();
    request.desc = this.filterDesc;
    request.idTipo = this.filterIdTipo;
    request.serialNumber = this.filterSerialNumber;
    request.dataAcquistoDa = this.datePipe.transform(this.filterDataAcquistoDa, this.pattern);
    request.dataAcquistoA = this.datePipe.transform(this.filterDataAcquistoA, this.pattern);
    request.codCespite = this.filterCodCespite;
    request.dataAlienazioneDa = this.datePipe.transform(this.filterDataAlienazioneDa, this.pattern);
    request.dataAlienazioneA = this.datePipe.transform(this.filterDataAlienazioneA, this.pattern);
    request.soloAttivi = this.filterSoloAttivi;
    this.equipmentService.getEquipments(this.userContext.srmToken, request).subscribe(
      result => {
        this.equipments = result.equipments;
        this.filterEquipments();
        this.loading = false;
        if (this.equipmentSelected != null && this.equipmentSelected.id > 0) {
          this.selectEquipment(this.equipmentSelected);
        }
        this.sort(this.sortField, this.sortAsc);
      },
      error => {
        this.handleError(error);
        this.loading = false;
      });
  }

  filterEquipments(checkboxName?) {
    if ('assegnate' == checkboxName && !this.filterAssegnate && !this.filterNonAssegnate) {
      this.filterNonAssegnate = true;
    } else if ('nonAssegnate' == checkboxName && !this.filterNonAssegnate && !this.filterAssegnate) {
      this.filterAssegnate = true;
    } 
    this.filteredEquipments = [];
    for (var i = 0; i < this.equipments.length; i++) {
      var current = this.equipments[i];
      if ((this.filterAssegnate && current.idAssegnatario != null) || (this.filterNonAssegnate && current.idAssegnatario == null)) {
        this.filteredEquipments.push(current);
      }
    };
    this.sort(this.sortField, this.sortAsc);
  }

  sort(field: string, asc?: boolean) {
    if (field === this.sortField && (typeof asc === 'undefined' || asc == !this.sortAsc)) {
      this.filteredEquipments = this.filteredEquipments.reverse();
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortField = field;
      this.filteredEquipments = this.filteredEquipments.sort((a1, a2) => {
        var res = 0;
        if (this.sortField === 'desc') {
          res = this.compareStrings(a1.desc, a2.desc);
        } else if (this.sortField === 'tipo') {
          res = this.compareStrings(a1.desTipo, a2.desTipo);
        } else if (this.sortField === 'sn') {
          res = this.compareStrings(a1.serialNumber, a2.serialNumber);
        } else if (this.sortField === 'cespite') {
          res = this.compareStrings(a1.codCespite, a2.codCespite);
        } else if (this.sortField === 'dtAcq') {
          res = this.compareDates(a1.dataAcquisto, a2.dataAcquisto);
        } else if (this.sortField === 'dtAlie') {
          res = this.compareDates(a1.dataAlienazione, a2.dataAlienazione);
        } else if (this.sortField === 'assegn') {
          res = this.compareStrings(a1.desAssegnatario, a2.desAssegnatario);
        }else if (this.sortField === 'note') {
          res = this.compareStrings(a1.note, a2.note);
        }
        return this.sortAsc ? res : -res;
      });
    }
  }

  private compareStrings(s1: string, s2: string) {
    return (s1 ? s1.toLowerCase() : '') > (s2 ? s2.toLowerCase() : '') ? 1 : -1;
  }

  private compareDates(d1: Date, d2: Date) {
    if (!d1 && !d2) {
      return 0;
    } else if (!d1) {
      return -1;
    } else if (!d2) {
      return 1;
    } else {
      return +new Date(d1) - +new Date(d2);
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  applyFilter() {
    this.loadEquipments();
    this.showFilter = false;
  }

  removeFilter() {
    this.resetFilter();
    this.loadEquipments();
    this.showFilter = false;
  }

  selectEquipment(equipment: Equipment) {
    this.validationMessage = null;
    this.equipmentSelected = equipment;
    this.equipmentId = equipment.id;
    this.equipmentDesc = equipment.desc;
    this.equipmentIdTipo = equipment.idTipo;
    this.equipmentSN = equipment.serialNumber;
    this.equipmentDataAcquisto = equipment.dataAcquisto ? new Date(equipment.dataAcquisto) : null;
    this.equipmentCodCespite = equipment.codCespite;
    this.equipmentDataAlienazione = equipment.dataAlienazione ? new Date(equipment.dataAlienazione) : null;
    this.equipmentMacAddress = equipment.macAddress;
    this.equipmentNote = equipment.note;
    this.loadEquipmentUsers(equipment.id);
  }

  addNewEquipment() {
    this.validationMessage = null;
    this.messageProvider.clearAll();
    this.equipmentSelected = new Equipment();
    this.equipmentId = null;
    this.equipmentDesc = '';
    this.equipmentIdTipo = null;
    this.equipmentSN = '';
    this.equipmentDataAcquisto = new Date();
    this.equipmentCodCespite = '';
    this.equipmentDataAlienazione = null;
    this.equipmentMacAddress = null;
    this.equipmentNote = '';
    this.equipmentUsers = [];
  }

  storeEquipment() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    if (this.equipmentDesc == null || this.equipmentDesc.length === 0) {
      this.validationMessage = 'Inserire la descrizione';
      return;
    }
    if (this.equipmentIdTipo == null) {
      this.validationMessage = 'Selezionare il tipo';
      return;
    }
    if (!this.typesWithMac.includes(this.equipmentIdTipo) || this.equipmentMacAddress == '') {
      this.equipmentMacAddress = null;
    }

    // modifica
    if (this.equipmentSelected.id > 0) {
      this.busyProvider.showBusyIndicator();
      this.equipmentService.updateEquipment(this.userContext.srmToken, this.equipmentId, this.equipmentDesc, this.equipmentIdTipo, this.equipmentSN, this.equipmentDataAcquisto, 
                                            this.equipmentCodCespite, this.equipmentDataAlienazione, this.equipmentMacAddress, this.equipmentNote).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: 'Modifica eseguita correttamente'});
          this.equipmentSelected = this.buildEquipment(this.equipmentId, this.equipmentDesc, this.equipmentIdTipo, this.equipmentSN, this.equipmentDataAcquisto, 
                                                       this.equipmentCodCespite, this.equipmentDataAlienazione, this.equipmentMacAddress, this.equipmentNote);
          this.loadEquipments();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
        });
    } else { // inserimento
      this.busyProvider.showBusyIndicator();
      this.equipmentService.insertEquipment(this.userContext.srmToken, this.equipmentDesc, this.equipmentIdTipo, this.equipmentSN, this.equipmentDataAcquisto, 
                                            this.equipmentCodCespite, this.equipmentDataAlienazione, this.equipmentMacAddress, this.equipmentNote).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: 'Inserimento eseguito correttamente'});
          this.equipmentId = Number(result.equipments[0].id);
          this.equipmentSelected = this.buildEquipment(this.equipmentId, this.equipmentDesc, this.equipmentIdTipo, this.equipmentSN, this.equipmentDataAcquisto,
                                                       this.equipmentCodCespite, this.equipmentDataAlienazione, this.equipmentMacAddress, this.equipmentNote);
          this.loadEquipments();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
        });
    }
  }

  buildEquipment(id, desc, idTipo, serialNumber, dataAcquisto, codCespite, dataAlienazione, macAddress, note) {
    const equipment: Equipment = new Equipment();
    equipment.id = id;
    equipment.desc = desc;
    equipment.idTipo = idTipo;
    equipment.serialNumber = serialNumber;
    equipment.dataAcquisto = dataAcquisto;
    equipment.codCespite = codCespite;
    equipment.dataAlienazione = dataAlienazione;
    equipment.macAddress = macAddress;
    equipment.note = note;
    return equipment;
  }

  cloneEquipment(current: Equipment) {
	  this.validationMessage = null;
	  this.messageProvider.clearAll();
	
	  // Modalita'�"nuova attrezzatura"
	  this.equipmentSelected = new Equipment();
	  this.equipmentId = null;
	
	  // Campi clonati
	  this.equipmentDesc = current.desc;
	  this.equipmentIdTipo = current.idTipo;
	  this.equipmentDataAcquisto = current.dataAcquisto ? new Date(current.dataAcquisto) : null;
	  this.equipmentDataAlienazione = current.dataAlienazione ? new Date(current.dataAlienazione) : null;
	  this.equipmentMacAddress = current.macAddress;
	
	  // Campi NON clonati perché devono essere unici/nuovi
	  this.equipmentSN = '';
	  this.equipmentCodCespite = '';
	  this.equipmentNote = '';
	
	  // Pulizia storico/assegnazioni
	  this.equipmentUsers = [];
	  this.equipmentUsersStorico = [];
  }

  openDeleteAlert(current: Equipment) {
    this.selectEquipment(current);
    this.showDeleteAlert = true;
  }
  closeDeleteAlert() {
    this.showDeleteAlert = false;
  }

  deleteEquipment() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    this.busyProvider.showBusyIndicator();
    this.equipmentService.deleteEquipment(this.userContext.srmToken, this.equipmentId).subscribe(
      result => {
        this.busyProvider.hideBusyIndicator();
        this.msgs = [];
        this.msgs.push({severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente'});
        this.addNewEquipment();
        this.loadEquipments();
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
  }

  openManageEquipmentTypes() {
    this.showEquipmentTypesDialog = true;
    this.equipmentType = new EquipmentType();
  }

  storeNewEquipmentType() {
    this.equipmentService.insertEquipmentType(this.userContext.srmToken, this.equipmentType.desc, this.equipmentType.flagMac).subscribe(
      result => {
        this.busyProvider.hideBusyIndicator();
        this.msgs = [];
        this.msgs.push({severity: 'success', summary: 'OK', detail: 'Inserimento eseguito correttamente'});
        this.loadEquipmentTypes();
        this.equipmentType = new EquipmentType();
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
  }

  confirmDeleteEquipmentType(equipmentType: SelectItem) {
    this.confirmationService.confirm({
      key: 'deleteEquipmentTypeConfirm',
      message: 'Eliminare ' + equipmentType.label + '?',
      accept: () => {
        this.equipmentService.deleteEquipmentType(this.userContext.srmToken, equipmentType.value).subscribe(
          result => {
            this.busyProvider.hideBusyIndicator();
            this.msgs = [];
            this.msgs.push({severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente'});
            this.loadEquipmentTypes();
          },
          error => {
            this.busyProvider.hideBusyIndicator();
            this.handleError(error);
          });
      }
    });
  }

  loadEquipmentUsers(idEquip) {
    this.equipmentUsers = [];
    this.equipmentUsersStorico = [];
    if (idEquip != null) {
      const request = new EquipmentUsersRequest();
      request.idEquip = idEquip;
      this.equipmentService.getEquipmentUsers(this.userContext.srmToken, request).subscribe(
        result => {
          this.equipmentUsers = result.results;
          this.equipmentUsers = this.equipmentUsers.sort((a, b) => {
            return this.compareDates(b.dataInizioAssegnaz, a.dataInizioAssegnaz);
          });
          if (this.equipmentUsers.length > 0) {
            this.equipmentUsersStorico = this.equipmentUsers.filter(function(element, index, array) {
              return element.dataFineAssegnaz != null;
            });
            this.equipmentUsers = this.equipmentUsers.filter(function(element, index, array) {
              return element.dataFineAssegnaz == null;
            });
          }
        },
        error => {
          this.handleError(error);
          this.loading = false;
        });
    }
  }

  loadUsers() {
    this.users = [];
    this.userService.getUsers(this.userContext.srmToken, true, false).subscribe(
      result => {
        this.users.push({label: '', value: null});
        for (let i = 0; i < result.users.length; ++i) {
          const current: User = result.users[i];
          this.users.push({label: current.fullname, value: current.id});
        }
      },
      error => {
        this.handleError(error);
      });
  }

  openAssignDialog(current: Equipment) {
    this.selectEquipment(current);
    this.assignIdUser = null;
    if (this.users.length == 0) {
      this.loadUsers();
    }
    this.showAssignDialog = true;
  }

  closeAssignDialog() {
    this.showAssignDialog = false;
  }

  assignEquipment() {
    this.messageProvider.clearAll();
    this.busyProvider.showBusyIndicator();
    this.equipmentService.upsertEquipmentUser(this.userContext.srmToken, true, null, this.assignIdUser, this.equipmentId, new Date()).subscribe(
      result => {
        this.busyProvider.hideBusyIndicator();
        this.msgs = [];
        this.msgs.push({severity: 'success', summary: 'OK', detail: 'Assegnazione eseguita correttamente'});
        this.loadEquipments();
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
  }

  openDeAssignDialog(current: Equipment) {
    this.selectEquipment(current);
    this.showDeAssignAlert = true;
  }

  closeDeAssignAlert() {
    this.showDeAssignAlert = false;
  }

  deassignEquipment() {
    if(this.equipmentUsers.length > 0) {
      this.busyProvider.showBusyIndicator();
      this.equipmentService.upsertEquipmentUser(this.userContext.srmToken, false, this.equipmentUsers[0].id, this.equipmentUsers[0].idUser, this.equipmentUsers[0].idEquip, this.equipmentUsers[0].dataInizioAssegnaz, new Date()).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: true ? 'Inserimento eseguito correttamente' : 'Modifica eseguita correttamente'});
          this.loadEquipments();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
      });
    }
  }

  goToEquip(equipUser: EquipmentUser) {
    var equip = this.filteredEquipments.find(e => e.id == equipUser.idEquip);
    this.selectEquipment(equip);
    this.toScroll = true;
  }
  
  ngAfterViewChecked(): void {
    if(this.toScroll) {
      var element = document.getElementById(this.equipmentId.toString())
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
      this.toScroll = false;
    }
  }

  

}



// WEBPACK FOOTER //
// ./src/app/equipment-defs/equipment-defs.component.ts